import { behaviorOpenFormTopic, topicContentCssPath, topicFormCssPath, topicsTable } from './cssPaths.js';
import { initView, initTable } from '../commonControllers.js';

export const view = initView({
  formCssPath: topicFormCssPath,
  contentCssPath: topicContentCssPath,
  cssPathToElemBehaviorOpenForm: behaviorOpenFormTopic,
});
export const table = initTable({
  tableCssPath: topicsTable,
  prepareColumns: (channel) => [
    channel.key,
    [channel.emailChannel.type, channel.smsChannel.type].filter((channelType) => channelType).join(', '),
  ],
});
export * as form from './form.js';
